// src/App.js
import React from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import pages
import Form from './pages/form';
import Card from './pages/card';
import Navbar from './components/nav-bar';
import TestForm from './pages/form2';
import Table from './pages/VendorTable';
import Actions from './pages/VendorActions';
import Dashboard from './pages/Dashboard';
import Login from './pages/auth/login';
// import Register from './pages/auth/register';

// Import PrivateRoute
import PrivateRoute from './components/PrivateRoute';

const App = () => {
  return (
    <Router>
      <NavbarWithLocation />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}

        {/* Private Routes (Require authentication) */}
        <Route path="/" element={<PrivateRoute element={<Form />} />} />
        <Route path="/cards" element={<PrivateRoute element={<Card />} />} />
        <Route path="/testform" element={<PrivateRoute element={<TestForm />} />} />
        <Route path="/table" element={<PrivateRoute element={<Table />} />} />
        <Route path="/actions" element={<PrivateRoute element={<Actions />} />} />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
        {/* <Route path="/register" element={<PrivateRoute element={<Register />} />} /> */}
      </Routes>
    </Router>
  );
};

// NavbarWithLocation component to conditionally render the Navbar
const NavbarWithLocation = () => {
  const location = useLocation();
  const shouldShowNavbar = location.pathname !== "/login" && location.pathname !== "/register";
  
  return shouldShowNavbar ? <Navbar /> : null;
};

export default App;
